import { Brain, Heart, Ribbon, Spark, User, Users } from "../icons";

const RATES = {
  standard: [
    ["First Intake Assessment", "60 min", "R450"],
    ["Standard Online Session", "60 min", "R550"],
    ["Standard Online Session", "45 min", "R420"],
    ["Students / Unemployed", "60 min", "R350"],
    ["Students / Unemployed", "45 min", "R280"],
  ],
  couples: [
    ["Couples Intake Assessment", "60 min", "R600"],
    ["Couples Counselling", "60 min", "R700"],
    ["Couples Counselling", "90 min", "R950"],
  ],
  groups: [
    ["Group Intake Assessment", "60 min", "R200 per person", "Minimum 4 people"],
    ["Group Session", "60 min", "R250 per person", "Minimum 4 people"],
    ["Individual Debriefing", "45–60 min", "R500"],
    ["Group Debriefing", "60–90 min", "R300 per person", "Minimum 4 people"],
  ],
};

function Rates({ rows }: { rows: string[][] }) {
  return (
    <ul className="rate-list">
      {rows.map((row) => (
        <li key={row[0] + row[1]}>
          <div><span style={{ fontWeight: 600 }}>{row[0]}</span>{row[3] && <span className="note">{row[3]}</span>}</div>
          <span className="dur">{row[1]}</span>
          <span className="cost">{row[2]}</span>
        </li>
      ))}
    </ul>
  );
}

export function Services() {
  const kinds = [
    { icon: <User />, title: "Individual Counselling", blurb: "A dedicated space to explore what's weighing on you and rediscover what supports you." },
    { icon: <Brain />, title: "Trauma Support", blurb: "Gentle, paced work to process difficult experiences with practical coping techniques." },
    { icon: <Ribbon />, title: "HIV / TB Wellness Support", blurb: "Focused psychosocial care for individuals and families affected by chronic illness." },
    { icon: <Spark />, title: "Holistic Counselling", blurb: "An integrative approach tending to mind, body, and spirit together." },
  ];
  return (
    <>
      <section className="wrap-m center" style={{ padding: "4rem 0 2.5rem" }}>
        <h1>Services & Rates</h1>
        <p className="soft">All sessions take place online — a gentle, unhurried space to meet wherever you are.</p>
      </section>
      <section className="wrap" style={{ paddingBottom: "3.5rem" }}>
        <div className="cards-4">
          {kinds.map((item) => (
            <article className="card center" key={item.title}>
              <div className="icon-bubble icon-sm">{item.icon}</div>
              <h3 style={{ fontSize: "1.25rem" }}>{item.title}</h3>
              <p className="muted" style={{ fontSize: "0.875rem" }}>{item.blurb}</p>
            </article>
          ))}
        </div>
        <p className="center muted" style={{ fontSize: "0.875rem" }}>All of the above are billed at the standard online rates below.</p>
      </section>
      <section className="wrap-s" style={{ paddingBottom: "3.5rem" }}>
        <div className="panel sage">
          <h2 style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}><User /> Standard Online Sessions</h2>
          <p className="soft" style={{ fontSize: "0.875rem" }}>Individual, trauma, HIV/TB wellness and holistic counselling.</p>
          <Rates rows={RATES.standard} />
        </div>
      </section>
      <section className="wrap-s" style={{ paddingBottom: "3.5rem" }}>
        <div className="panel peach">
          <h2 style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}><Heart /> Couples Counselling</h2>
          <p className="soft" style={{ fontSize: "0.875rem" }}>Support for couples navigating communication, trust, or conflict.</p>
          <Rates rows={RATES.couples} />
        </div>
      </section>
      <section className="wrap-s" style={{ paddingBottom: "3.5rem" }}>
        <div className="panel lavender">
          <h2 style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}><Users /> Groups & Debriefing</h2>
          <p className="soft" style={{ fontSize: "0.875rem" }}>Facilitated group work for shared experiences, community healing and workplace debriefing.</p>
          <Rates rows={RATES.groups} />
        </div>
      </section>
      <section className="wrap-s center" style={{ paddingBottom: "4rem" }}>
        <div className="pill-note"><span>Evening / Weekend sessions: <strong>+R100</strong> on top of the relevant rate above.</span></div>
        <p><a className="btn" href="/book">Book a Session</a></p>
      </section>
    </>
  );
}
